module.exports = __webpack_public_path__ + "static/img/ism-education-logo.3a93ec68.png";